// Вхід / прив'язка за КЕП через DSTUcrypt (https://dstucrypt.com.ua/llms.md)
// Один віджет: файловий ключ, Дія.Підпис і Smart ID (ПриватБанк)
const SDK_URL = 'https://dstucrypt.io/embed/dstucrypt-embed.mjs';

let sdk = null;

// SDK — зовнішній ES-модуль, тому імпортуємо його в обхід webpack
function loadSdk() {
  if (!sdk) {
    sdk = new Function('url', 'return import(url)')(SDK_URL).catch((err) => {
      sdk = null;
      throw err;
    });
  }
  return sdk;
}

// Відкриває віджет і підписує challenge з бекенда. Повертає { challenge, signature } для перевірки на бекенді
// provider: 'file' | 'diia' | 'smartid' — одразу потрібний спосіб без перемикача; без нього — вибір у віджеті
export async function signKepChallenge(challenge, provider) {
  const { embed } = await loadSdk();
  const widget = await embed('auth', { mount: 'modal', providers: provider ? [provider] : ['file', 'diia', 'smartid'] });
  const result = await widget.login({ challenge });

  return {
    // для Дії challenge задає сервер DSTUcrypt і повертає його в result.challenge
    challenge: result.challenge || challenge,
    signature: typeof result.signature === 'string' ? result.signature : result.signature.base64,
  };
}

// not_licensed / load_failed віджет показує сам, CANCELLED — користувач закрив вікно
export function isKepSilentError(err) {
  return ['not_licensed', 'load_failed', 'CANCELLED'].includes(err && err.code);
}
